export default class SubForDrops extends HTMLElement {
  constructor() {
    super();
    this.lineWithArrow = this.querySelector("#line-with-arrow");
  }

  connectedCallback() {
    this.setLineWithArrowWidths();
    window.addEventListener("resize", this.setLineWithArrowWidths.bind(this));
  }

  setLineWithArrowWidths() {
    const items = this.querySelectorAll(".item");
    const itemWidth = this.querySelector(".item").offsetWidth;

    if (window.innerWidth >= 1920) {
      this.lineWithArrow.style.width = `${itemWidth * items.length + (items.length - 1) * 35}px`;
    } else if (window.innerWidth >= 1000) {
      this.lineWithArrow.style.width = `${itemWidth * items.length + (items.length - 1) * 31}px`;
    } else {
      this.lineWithArrow.style.width = `${itemWidth * items.length + (items.length - 1) * 10}px`;
    }
  }
}

customElements.define("sub-for-drops", SubForDrops);
